import { useState } from "react";
import { Check, Send } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const ContactForm = ({ accent = "#FF00DD" }) => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      setForm({ name: "", email: "", subject: "", message: "" });
      toast.success("¡Mensaje enviado! Te responderemos pronto.");
    } catch (err) {
      toast.error("No se pudo enviar el mensaje. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div
        data-testid="contact-success"
        className="bg-white border border-[#E5E5E5] rounded-sm p-10 text-center"
      >
        <div
          className="w-14 h-14 rounded-full mx-auto flex items-center justify-center"
          style={{ background: accent }}
        >
          <Check className="text-white" size={28} />
        </div>
        <h3 className="mt-5 font-heading text-2xl font-bold text-brand-ink">¡Gracias!</h3>
        <p className="mt-2 text-brand-ink/70">Hemos recibido tu mensaje y te contactaremos pronto.</p>
        <button
          data-testid="contact-send-another"
          onClick={() => setSent(false)}
          className="mt-6 font-semibold text-brand-magenta hover:underline"
        >
          Enviar otro mensaje
        </button>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="contact-form"
      className="bg-white border border-[#E5E5E5] rounded-sm p-8 space-y-5"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className="text-sm font-semibold text-brand-ink">Nombre</label>
          <input
            required
            data-testid="contact-name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta transition-colors"
          />
        </div>
        <div>
          <label className="text-sm font-semibold text-brand-ink">Correo</label>
          <input
            required
            type="email"
            data-testid="contact-email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta transition-colors"
          />
        </div>
      </div>
      <div>
        <label className="text-sm font-semibold text-brand-ink">Asunto</label>
        <input
          data-testid="contact-subject"
          value={form.subject}
          onChange={(e) => setForm({ ...form, subject: e.target.value })}
          className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta transition-colors"
        />
      </div>
      <div>
        <label className="text-sm font-semibold text-brand-ink">Mensaje</label>
        <textarea
          required
          rows={5}
          data-testid="contact-message"
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta transition-colors resize-none"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="contact-submit"
        className="inline-flex items-center gap-2 bg-brand-ink text-white font-semibold px-6 py-3 rounded-sm hover:bg-brand-orange transition-colors duration-200 disabled:opacity-60"
      >
        {loading ? "Enviando..." : "Enviar mensaje"} <Send size={16} />
      </button>
    </form>
  );
};

export default ContactForm;
